import { useTheme } from '@mui/material/styles';
import { ReactNode, useCallback } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { FlexBoxFullWidth } from '../../../common/boxes';
import { useConfirmationDialog } from '../../../../+state/useConfirmationDialog';

interface Props {
  deleteHandler: () => void,
  editHandler: () => void,
  children: ReactNode,
}

const ProfileListItem = ({ children, deleteHandler, editHandler }: Props) => {
  const theme = useTheme();
  const { openDialog } = useConfirmationDialog();

  const openDeleteConfirmationDialog = useCallback(() => {
    openDialog({ cb: deleteHandler });
  }, [openDialog, deleteHandler]);

  return (
    <FlexBoxFullWidth
      p={1} mb={1} py={2}
      alignItems={'center'}
      flexDirection={{ mobile: 'column', tablet: 'row' }}
      sx={{ borderBottom: 1, borderColor: theme.palette.grey.A200 }}
    >
      {children}
      <FlexBoxFullWidth justifyContent={'space-between'} flexShrink={10} mt={{ mobile: 2, tablet: 0 }}>
        <Tooltip title={'Delete'}>
          <IconButton onClick={openDeleteConfirmationDialog} color={'error'}>
            <Delete/>
          </IconButton>
        </Tooltip>
        <Tooltip title={'Edit'}>
          <IconButton color={'primary'} onClick={editHandler}>
            <Edit/>
          </IconButton>
        </Tooltip>
      </FlexBoxFullWidth>
    </FlexBoxFullWidth>
  );
};

export default ProfileListItem;